<template lang="html">
  <div id="loader-wrapper" v-if="!fetched">
    <div id="loader"></div>
    <div class="loader-section section-left"></div>
    <div class="loader-section section-right"></div>
  </div>
  <div class="vendor-detail" v-else>
    <b-modal
      id="success-modal"
      v-model="messageSent"
      centered
      title="BootstrapVue"
    >
      <p class="my-4" style="padding-left:20px;">Message Sent</p>
    </b-modal>
    <div class="bumper"></div>
    <b-container class="breadcrumb-container">
      <b-row>
        <b-col>
          <div class="breadcrumb">
            <a href="/vendor">Vendor Explore</a>
            <span class="divider"> / </span>
            <a href="/vendor">{{
              vendor.vendorCities && vendor.vendorCities[0].city
                ? vendor.vendorCities[0].city.name
                : ""
            }}</a>
            <span class="divider"> / </span>
            <span class="current">{{ vendor.name }}</span>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="maincontent">
      <label v-if="vendor.highlighted == 1" class="premium-vendor">
        Premium Vendor
      </label>
      <b-row>
        <b-col lg="6" md="12" class="pos-relative">
          <div class="company-contact-badge">
            <b-row>
              <b-col lg="5" md="12" class="logo">
                <img
                  :src="
                    vendor.logo ? vendor.logo : '/images/shipyard-occupancy.png'
                  "
                  alt="company_name"
                />
                <!-- <div class="share-box desktop-only">
                  <span>Share this vendor :</span>
                  <ul>
                    <li><a href="#" class="fb"></a></li>
                    <li><a href="#" class="linkedin"></a></li>
                    <li><a href="#" class="twitter"></a></li>
                    <li><a href="#" class="email"></a></li>
                  </ul>
                </div> -->
              </b-col>
              <b-col lg="7" md="12">
                <h2 class="company-name">{{ vendor.name }}</h2>
                <div class="company-location">
                  <span class="city"
                    >City :
                    {{
                      vendor.vendorCities && vendor.vendorCities[0].city
                        ? vendor.vendorCities[0].city.name
                        : ""
                    }}</span
                  >
                </div>
                <b-row class="contact-list">
                  <b-col class="label" sm="3" cols="3" lg="3">
                    Phone
                  </b-col>
                  <b-col class="content" sm="9" cols="9" lg="9">
                    : <a :href="'tel:' + vendor.phone"> {{ vendor.phone }} </a>
                  </b-col>
                </b-row>

                <b-row class="contact-list">
                  <b-col class="label" sm="3" cols="3" lg="3">
                    Website
                  </b-col>
                  <b-col class="content" sm="9" cols="9" lg="9">
                    : <a :href="'http://'+ vendor.website"> {{ vendor.website }} </a>
                  </b-col>
                </b-row>

                <b-row class="contact-list">
                  <b-col class="label" sm="3" cols="3" lg="3">
                    Email
                  </b-col>
                  <b-col class="content" sm="9" cols="9" lg="9">
                    :
                    <a :href="'mailto:' + vendor.email"> {{ vendor.email }} </a>
                  </b-col>
                </b-row>

                <!-- <div class="share-box mobile-only">
                  <span>Share this vendor :</span>
                  <ul>
                    <li><a href="#" class="fb"></a></li>
                    <li><a href="#" class="linkedin"></a></li>
                    <li><a href="#" class="twitter"></a></li>
                    <li><a href="#" class="email"></a></li>
                  </ul>
                </div> -->
              </b-col>
            </b-row>
            <a
              name="button"
              class="kirim-pesan"
              v-if="account"
              v-b-modal.modalMessageShipyard
              >Message Vendor</a
            >
            <a
              name="button"
              class="kirim-pesan"
              style="font-size:15px;"
              @click="openLoginPopup"
              v-if="!account"
              >Login for send message to this vendor</a
            >
          </div>
        </b-col>

        <b-col lg="6" md="12">
          <div>
            <b-carousel
              v-if="vendor.images.length"
              id="carousel1"
              class="vendor-image-detail"
              style="text-shadow: 1px 1px 2px #333; border-radius:5px; overflow:hidden;"
              controls
              indicators
              background="#ababab"
              :interval="4000"
              img-width="1024"
              img-height="400"
              v-model="slide"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
            >
              <b-carousel-slide
                v-for="(image, i) in vendor.images"
                :key="i"
                :img-src="image.image"
              />
            </b-carousel>
            <b-carousel
              v-else
              id="carousel1"
              class="vendor-image-detail"
              style="text-shadow: 1px 1px 2px #333; border-radius:5px; overflow:hidden;"
              controls
              indicators
              background="#ababab"
              :interval="4000"
              img-width="1024"
              img-height="400"
              v-model="slide"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
            >
              <b-carousel-slide
                img-src="https://picsum.photos/1024/480/?image=58"
              />
            </b-carousel>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <div class="col-lg-6">
          <div class="company-desc">
            <h1 class="company-title">
              {{ vendor.name }}
            </h1>
          </div>
        </div>
        <div class="col-lg-6">
          <a
            name="button"
            class="download-brochure"
            target="_blank"
            :href="vendor.brochure"
            v-if="vendor.brochure"
            >Download vendor brochure
            <img src="/images/icons/pdf.png" alt="brochure"
          /></a>
        </div>

        <div class="col-lg-12">
          <p class="">
            {{ vendor.description || "Description : TBA" }}
          </p>
        </div>
      </b-row>

      <div v-if="vendor.highlighted == 1" >

        <b-row class="projects" v-if="vendor.customers && vendor.customers.length">
          <b-col>
            <div>
              <h3>Projects:</h3>
              <b-row>
                <b-col
                  lg="3"
                  md="3"
                  sm="6"
                  v-for="(customer, i) in vendor.customers"
                  :key="i"
                >
                  <div
                    class="card inner-img"
                    @click="openCustomersDesc(customer)"
                  >
                    <img
                      class="card-img-top"
                      :src="customer.projectPhoto"
                      alt=""
                    />
                    <div class="card-body">
                      <h5 class="card-title">{{ customer.projectName }}</h5>
                      <p>{{ customer.year }}</p>
                      <!-- <a href="#" class="btn btn-primary">See Detail Project</a> -->
                    </div>
                    <div class="display-box projects-card">
                      <div class="text">
                        <p style="color:#fff; text-align:center;">Customer:</p>
                        <img
                          style="width:100%;"
                          :src="customer.logo"
                          alt=""
                        />
                        <p class="vendor-name">{{ customer.name }}</p>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>

      </div>

    </b-container>

    <b-container class="others-vendor">
      <h3 class="mtop-20 mbtm-20">
        Vendor lainya di kota
        {{
          vendor.vendorCities && vendor.vendorCities[0].city
            ? vendor.vendorCities[0].city.name
            : ""
        }}:
      </h3>
      <div class="row" style="padding-bottom:40px">
        <div
          v-for="vendor in vendorsByCity"
          class="col-lg-3 col-sm-6 col-md-4 vendor-related"
        >
          <a :href="'' + vendor.slug">
            <div class="card">
              <div class="box-img">
                <img
                  class="card-img-top"
                  :src="
                    vendor.images.length
                      ? vendor.images[0].image
                      : '/images/shipyard-occupancy.png'
                  "
                  alt="vendor.name"
                />
                <div class="vendor-logo">
                  <img
                    :src="
                      vendor.logo
                        ? vendor.logo
                        : '/images/shipyard-occupancy.png'
                    "
                    alt="vendor.name"
                  />
                </div>
              </div>
              <div class="card-body">
                <h5 class="card-title">{{ vendor.name }}</h5>
                <p class="city">
                  <i></i
                  ><span>{{
                    vendor.vendorCities && vendor.vendorCities[0]
                      ? vendor.vendorCities[0].city.name
                      : ""
                  }}</span>
                </p>
                <b-badge variant="warning">{{
                  vendor.vendorServices && vendor.vendorServices[0]
                    ? vendor.vendorServices[0].service.name
                    : ""
                }}</b-badge>
              </div>
            </div>
          </a>
        </div>
      </div>
    </b-container>

    <ModalMessageShipyard :shipyard="vendor" @onMessageSent="onMessageSent" />
    <ModalCustomers :customer="currentCustomer" />
  </div>
</template>

<script>
import VendorAPI from "~/api/vendors.js";
import ModalMessageShipyard from "~/components/modal/shipyard-message-form";
import ModalCustomers from "~/components/modal/customers-description";

export default {
  components: {
    ModalMessageShipyard,
    ModalCustomers
  },
  head() {
    let title_page =
      this.vendor && this.vendor.name
        ? this.vendor.name
        : "Marine vendor di docking.id";
    return {
      title: `${title_page} | ${
        this.vendor && this.vendor.name ? this.vendor.name : ""
      }`,
      meta: [
        {
          name: "description",
          hid: "description",
          content: `Lihat profile ${this.vendor.name} di docking.id`
        },
        {
          name: "keywords",
          hid: "keywords",
          content: `${this.vendor.name}, ${
            this.vendor.vendorServices && this.vendor.vendorServices[0]
              ? this.vendor.vendorServices[0].service.name
              : ""
          }, ${
            this.vendor.vendorCities && this.vendor.vendorCities[0]
              ? this.vendor.vendorCities[0].city.name
              : ""
          }`
        },
        // Open Graph
        {
          property: "og:title",
          content: `${
            this.vendor ? this.vendor.name : "Vendor Maritim di"
          } | DOCKING.ID`
        },
        {
          property: "og:description",
          content: `Lihat profile ${this.vendor.name} di docking.id`
        },
        { property: "og:type", content: "website" },
        {
          property: "og:url",
          content: `https://www.docking.id/vendor/profile/${this.vendor.slug}`
        },
        { property: "og:image", content: `${this.vendor.logo}` },
        // Twitter Card
        {
          name: "twitter:card",
          content: `${
            this.vendor ? this.vendor.name : "Vendor Maritim di"
          } | DOCKING.ID`
        },
        {
          name: "twitter:site",
          content: `https://www.docking.id/vendor/profile/${this.vendor.slug}`
        },
        {
          name: "twitter:title",
          content: `${
            this.vendor ? this.vendor.name : "Vendor Maritim di"
          } | DOCKING.ID`
        },
        {
          name: "twitter:description",
          content: `Lihat profile dan kontak ${this.vendor.name} di docking.id`
        },
        { name: "twitter:image", content: `${this.vendor.logo}` },
        {
          name: "twitter:image:alt",
          content: "https://www.docking.id/images/OG_IMAGE_DOCKING_ID.png"
        }
      ]
    };
  },
  data() {
    return {
      messageSent: false,
      vendor: {
        name: null,
        city: null,
        images: [],
        customers: []
      },
      vendorsByCity: [],
      vendorCustomers: [],
      limit: 4,
      slide: 0,
      sliding: null,
      fetched: false,
      currentCustomer: {}
    };
  },
  computed: {
    account() {
      let data = this.$store.state.account.account;

      if (data && data.type == "user") data.detail = data.user;
      else if (data && data.type == "shipyard") data.detail = data.shipyard;
      else if (data && data.type == "vendor") data.detail = data.vendor;

      return data;
    },
    lang() {
      return this.$store.state.lang.locale;
    }
  },
  methods: {
    openCustomersDesc(customer) {
      this.currentCustomer = customer;
      this.$root.$emit("bv::show::modal", "modalCustomers");
    },
    openLoginPopup() {
      this.$root.$emit("bv::show::modal", "modalLogin");
    },
    onMessageSent() {
      this.messageSent = true;
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    getVendor() {
      let vendorApi = new VendorAPI(this.$axios);
      let slug = this.$route.params.slug;
      let _this = this;

      vendorApi.get(slug).then(res => {
        _this.vendor = res.data;
        _this.getVendorsByCity(res.data.vendorCities[0].city.id);
        //_this.getVendorCustomer();
      });
    },
    getVendorsByCity(cityId) {
      let vendorApi = new VendorAPI(this.$axios);
      let _this = this;

      vendorApi
        .getAll({
          city_id: cityId,
          limit: this.limit,
          except: this.$route.params.slug
        })
        .then(res => {
          //console.log(res.data.data)
          this.vendorsByCity = res.data.data;
          this.fetched = true;
        });
    }
    // getVendorCustomer() {
    //   let vendorApi = new VendorAPI(this.$axios);
    //   let slug = this.$route.params.slug;
    //   console.log("slut => ", slug);
    //   let _this = this;

    //   vendorApi
    //     .getAllCustomer({
    //       name: slug
    //     })
    //     .then(res => {
    //       console.log(" ===> ", res.data.data);
    //       this.vendorCustomers = res.data;
    //       this.fetched = true;
    //     })
    //     .catch(err => {
    //       console.log("error => ", err);
    //     });
    // }
  },
  created() {
    this.getVendor();
  }
};
</script>

<style lang="scss">
@import "~/assets/scss/_mixins.scss";
@import "./style.scss";
</style>
